import React, { useContext, useEffect, useState } from "react";
import Pagereview from "../../components/pageReview/Pagereview";
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import EventVariantCard from "../../components/cards/eventVariantCard/EventVariantCard";
import { getNewDetail } from "../../utils/apiCalls";
import moment from "moment";
import { FormContext } from "../CMSRenderer/CMSRenderer";

const MediaCenterDetails = ({ config }) => {
  const [newDetail, setNewDetail] = useState({});
  const { currentLang } = useContext(FormContext);

  useEffect(() => {
    getNewDetail({ newID: config?.detail_id || "" }).then((res) => {
      setNewDetail(res?.data || {});
    });
  }, config?.detail_id);

  return (
    <>
      <h3 className="md:!my-4 my-2 Medium text-primary">
        {currentLang === "en" ? config.title : config.title_ar}
      </h3>

      <div className="lg:flex rounded-2xl  items-center gap-8">
        <img
          src={require("../../assets/images/mediaCenter.png")}
          alt="news img"
          className="lg:w-1/3 lg:max-h-none max-h-[200px] w-full object-cover rounded-xl"
        />
        <div className="flex-1 lg:mt-0 mt-3">
          <p className="text-primary p-2 bg-customSurface w-fit rounded-lg">
            {moment(new Date(newDetail?.publishDate))?.format(
              "dddd, MMMM DD, YYYY"
            ) || ""}
          </p>
          <h6 className="lg:my-7 my-4 Medium">
            {currentLang === "en"
              ? newDetail?.titleEn
              : newDetail?.titleAr || ""}
          </h6>

          <div className="flex md:gap-4 gap-2">
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FaTwitter className="text-primary text-2xl" />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FaFacebook className="text-primary text-2xl" />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FaLinkedin className="text-primary text-2xl" />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="text-primary text-2xl" />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FiDownload className="text-primary text-2xl" />
            </a>
          </div>
        </div>
      </div>

      <p
        className="md:!my-6 my-4 text-onSurfaceVariant body"
        dangerouslySetInnerHTML={{
          __html:
            currentLang === "en"
              ? newDetail?.descriptionEn
              : newDetail?.descriptionAr || "",
        }}
      ></p>
      {/* <h5>News</h5>
      <div className="grid lg:grid-cols-3 sm:grid-cols-2 gap-8 mt-4">
        <EventVariantCard
          image={require("../../assets/images/mediaCenter.png")}
          date={{ month: "Oct", day: "26" }}
          title="World-class Quality"
          description="The Dubai Health Authority is committed to always maintaining a leading position in global healthcare,..."
          link="/mediaCenter/mediaCenterDetails"
        />
        <EventVariantCard
          image={require("../../assets/images/mediaCenter.png")}
          date={{ month: "Oct", day: "26" }}
          title="World-class Quality"
          description="The Dubai Health Authority is committed to always maintaining a leading position in global healthcare,..."
          link="/mediaCenter/mediaCenterDetails"
        />
        <EventVariantCard
          image={require("../../assets/images/mediaCenter.png")}
          date={{ month: "Oct", day: "26" }}
          title="World-class Quality"
          description="The Dubai Health Authority is committed to always maintaining a leading position in global healthcare,..."
          link="/mediaCenter/mediaCenterDetails"
        />
      </div> */}
      
    </>
  );
};

export default MediaCenterDetails;
